import { render, staticRenderFns } from "./SheetHeader.vue?vue&type=template&id=56ef3204&scoped=true"
import script from "./SheetHeader.vue?vue&type=script&lang=ts"
export * from "./SheetHeader.vue?vue&type=script&lang=ts"
import style0 from "./SheetHeader.vue?vue&type=style&index=0&id=56ef3204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef3204",
  null
  
)

export default component.exports